import { observer } from 'mobx-react-lite'
import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

// evertel
import { InfoBox, Card, CardBody, Button, Col, Row, FormInput, useUI } from '@evertel/web/ui'
import { isValidEmail } from '@evertel/utils'
import { useService } from '@evertel/di'
import { LoginService } from '@evertel/session/LoginService'
import { Analytics } from '@evertel/analytics'

const ForgotPassword: React.FC = observer(() => {

    const analytics = useService(Analytics)
    const loginService = useService(LoginService)
    // const [searchParams] = useSearchParams()
    // const emailParam = searchParams.get('email') || ''
    const { state } = useLocation()
    const emailParam = state?.email || ''

    const { showAppLoader } = useUI()

    const navigate = useNavigate()

    const [email, setEmail] = useState<string>(emailParam)
    const [alertText, setAlertText] = useState<string | null>(null)
    const [alertColor, setAlertColor] = useState<'success' | 'danger'>('success')
    const [isLoading, setIsLoading] = useState<boolean>(false)


    useEffect(() => {
        analytics.logView('/login/forgot-password')
    }, [])

    const resetPassword = async (): Promise<void> => {
        const emailTrim = email?.trim()

        if (!emailTrim) {
            setAlertText('Please enter an email address')
            setAlertColor('danger')
            return
        }

        if (!isValidEmail(emailTrim)) {
            setAlertText('Please enter a valid email address')
            setAlertColor('danger')
            return
        }


        showAppLoader({ isOpen: true, type: 'default' })
        setIsLoading(true)
        setAlertText(null)

        try {
            const response = await loginService.requestPasswordReset(emailTrim)

            setAlertText(response && response.message || `An email has been sent to ${email} with password reset instructions`)
            setAlertColor('success')

        } catch (error: any) {
            setAlertText(error.message || error)
            setAlertColor('danger')

        } finally {
            setIsLoading(false)
            showAppLoader({ isOpen: false, type: 'default' })
        }

    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setEmail(e.target.value)
    }

    return (
        <Row className="auth-layout animated">
            <Col valign="center" align="center"
                className="p-md-5 p-3"
                style={{ minHeight: '100vh', margin: 'auto', overflow: 'auto', maxWidth: 900 }}
            >
                <Card
                    className="p-4 pt-4 pb-4"
                    style={{
                        width: '500px',
                        maxWidth: 'calc(100vw - 30px)',
                        margin: '0 auto'
                    }}>
                    <CardBody>
                        <div className="text-center mb-5">
                            <img
                                src={'/assets/img/connect-logo-110x110.png'}
                                width="110"
                                alt="Evertel"
                                className="mb-4"
                            />
                            <h1>Can't log in?</h1>
                        </div>
                        {alertText && <InfoBox color={alertColor}>{alertText}</InfoBox>}
                        <FormInput
                            name="email"
                            value={email}
                            label="Enter your email"
                            placeholder="Email"
                            onChange={onChange}
                            leftIcon="at"
                        />
                        <Row className="flex-wrap">
                            <Col xs="12" className="mt-3">
                                <Button
                                    color="primary"
                                    className="px-4"
                                    loading={isLoading}
                                    onClick={resetPassword}>
                                    Send me a link
                                </Button>
                            </Col>
                            <Col xs="12" className="mt-3" align="center">
                                <Button
                                    onClick={() => navigate('/login')}
                                    color="link">
                                    Return to Login
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
})

export { ForgotPassword }
